/* URSA Tape page (6 Oct 2026, Simon feedback). Pack Size and Colour are linked, because 12 Small Strips Multi-Pack only exists as Colour = Multipack. Without this, clicking the Multi-Pack with Beige selected gave 'product selection unavailable'. Before the theme reads the picker, the matching radio in the other option is ticked silently. Undo: remove the script tag from layout/theme.liquid. */
(function () {
  if (!/\/products\/ursa-tape\/?$/.test(location.pathname)) return;
  var lastColour = 'Beige';
  function radios() { return [].slice.call(document.querySelectorAll('variant-picker input[type=radio]')); }
  function find(group, test) {
    return radios().filter(function (r) { return r.name.indexOf(group) === 0 && test(r.value); })[0] || null;
  }
  var isMulti = function (v) { return /^12 Small/i.test(v); };
  var is30 = function (v) { return /^30 Small/i.test(v); };
  document.addEventListener('click', function (e) {
    var r = e.target;
    if (!r || r.tagName !== 'INPUT' || r.type !== 'radio' || !r.closest || !r.closest('variant-picker')) return;
    if (r.name.indexOf('Pack Size') === 0) {
      var col = find('Colour', isMulti(r.value) ? function (v) { return v === 'Multipack'; } : function (v) { return v === lastColour; });
      if (col) col.checked = true;
    } else if (r.name.indexOf('Colour') === 0) {
      if (r.value !== 'Multipack') lastColour = r.value;
      var pk = find('Pack Size', r.value === 'Multipack' ? isMulti : is30);
      if (pk) pk.checked = true;
    }
  }, true);
})();
